import React from "react"
import WhatsappRedeemLink from "../../atoms/whatsapp-redeem-link/whatsapp-redeem-link"

import Button from "../../../shared/components/atoms/button/button"
import GenericModal from "../../../shared/components/modals/generic-modal/generic-modal"
import { siteUrl } from "../../../shared/utils/siteUrl"
import "./modal-redeem-success.scss"

const ModalRedeemSuccess = () => {
  //const { setModalClose } = props;

  const whatCanWinLink = siteUrl + "/mis-puntos/que-puedo-ganar"
  const myMovementsLink = siteUrl + "/mis-puntos/mis-movimientos";
  const default_message = (<>  Recuerda que para que se efectúe la redención tienes que
    enviarnos el formulario y los empaques por correspondencia o
    acercarte a alguna de las Famitiendas</>);
  const message = ({
    'es-CO': (<>  Recuerda que para que se efectúe la redención tienes que
      enviarnos tu formulario y las imágenes de tus empaques por
      nuestra linea de Whatsapp. <WhatsappRedeemLink />{" "}</>),
    'es-EC': (<> Recuerda estar pendiente de nuestro proveedor logístico, quien te contactará para efectuar tu redención. Gracias!!</>),
    'es-CL': (<>¡Muchas gracias por tu canje! Disfruta tu premio. Recuerda que debes guardar tu documento del formulario porque es la constancia de tu canje. Nuestro Proveedor Logístico Opus2 se comunicará contigo.</>)
  })[process.env.LOCALE] || default_message;

  return (
    <GenericModal>
      <span
        onClick={e => {
          e.preventDefault()
          window.location = whatCanWinLink
        }}
        className="icon2-close f-icon f-icon-close-modal"
      />
      <div className="f-modal-redeem-success-container">
        <div className="f-modal-redeem-success-container-title">
          <h1>Tu pedido ha quedado registrado</h1>
        </div>
        <div className="f-modal-redeem-success-container-wrap">

          {process.env.LOCALE !== "es-AR" && (
            <div className="f-modal-redeem-success-container-wrap-info">
              <p>{message}</p>
            </div>
          )}

        </div>
        <div className="f-section-options-redeem">
          <div className="f-section-options-redeem-wrap">
            <Button
              className="primary-pink"
              title="Aceptar"
              onClick={e => {
                e.preventDefault()
                window.location = whatCanWinLink
              }}
            />
            <a href={myMovementsLink}>Ir a mis pedidos</a>
          </div>
        </div>
      </div>
    </GenericModal>
  )
}

export default ModalRedeemSuccess
